import React from 'react';

import { Flight } from '@/API/models';
import ReactQueryProvider from '@/API/ReactQueryProvider';
import ChangeFlight, {
  ChangeFlightProps,
} from '@/components/Operator/ChangeFlight';
import DisplayFlight, {
  DisplayFlightProps,
} from '@/components/Operator/DisplayFlight';

type Props = {
  displayOnly?: boolean;
  change: Flight & { reason: string };
  comments: string;
} & DisplayFlightProps &
  ChangeFlightProps;

const ChangeRequest: React.FC<Props> = ({
  displayOnly = false,
  comments,
  change,
  ...props
}) => {
  return (
    <div>
      
      <ReactQueryProvider>
        {displayOnly ? (
          <DisplayFlight {...change} {...props} comments={comments} />
        ) : (
          <ChangeFlight {...change} {...props} comments={comments} />
        )}
      </ReactQueryProvider>
    </div>
  );
};
export default ChangeRequest;
